<template>
	
	<div class="appcontainer">
	
	<v-container fluid>
		<div style="margin-bottom:1rem;">
			<h1 class="text-2xl font-bold mb-1">GUIDA AL CLICK VELOCE</h1>
			<h3 class="font-semibold" style="color:#6D93CC">Linee Guida per i Cliccatori Professionisti</h3>
			<div>
				<p class="mb-4">Caro Cliccatore, in questa pagina troverai raccolti i migliori consigli e le tecniche più efficaci per aiutarti a ottimizzare la tua performance e affrontare il Click Day con sicurezza. Questi suggerimenti sono il risultato dell’esperienza maturata negli anni e sono stati testati con successo.
				</p>
					<p>Seguendo queste indicazioni potrai:</p>
				<ul>
						<li>superare con successo la selezione</li>
						<li>migliorare le tue prestazioni nel  Simulatore e ottenere risultati eccellenti durante il Click Day</li>
						<li>aumentare le tue probabilità di vincere i <strong>Game Day</strong> (previsti per questo bando)</li>
						<li>contribuire al successo dell’azienda che rappresenterai, permettendole di investire nei propri progetti grazie al tuo impegno.</li>
				</ul>
				<!-- <p class="mb-4">NB: in alcuni testi potresti trovare riferimenti ai Game Day, previsti per il bando INAIL ma non per il bando ISMEA.</p>
				<p class="mb-4"><b>Anche se i Game Day non saranno organizzati per ISMEA, i consigli condivisi rimangono utili per migliorare i tuoi tempi nelle simulazioni e perfezionare le tue abilità.</b></p>
				-->
				<p class="mb-4">Questa sezione verrà aggiornata regolarmente con nuovi suggerimenti per garantirti il supporto necessario a raggiungere il successo.</p> 
				<p>Buon allenamento! 💪</p>
			</div>
		</div>
	</v-container>
	
	<v-container fluid>
		<v-row>
      <v-col v-for="(item, index) in cardItems" :key="index" cols="3" class="d-flex flex-column align-stretch">

				
				<v-card
  class="d-flex flex-column align-center justify-center custom-card card-hover-animation same-size-card"
  @click="openGoogleDocDialog(item)"
  :style="`background-image: url(${item.image});`"
  :class="{
    'border-fondamentale': item.stato === 'FONDAMENTALE',
    'border-aggiornato': item.stato === 'AGGIORNATO',
    'border-nuovo': item.stato === 'NUOVO'
  }"
>
  <div class="overlay">
    <div
      v-if="item.stato"
      :class="[
        'status-badge',
        item.stato === 'FONDAMENTALE' ? 'status-fondamentale' :
        item.stato === 'AGGIORNATO' ? 'status-aggiornato' :
        item.stato === 'NUOVO' ? 'status-nuovo' : ''
      ]"
    >
      {{ item.stato }}
    </div>
    <h1>{{ index + 1 }}</h1>
    <p>{{ item.text }}</p>
  </div>
</v-card>
<div class="card-description">
					{{ item.desc }}
				</div>


      </v-col>
    </v-row>
	</v-container>

	
	<v-container fluid>
		<div style="margin-bottom:1rem;">
      <br>
      <div style="text-align:center;">
        <p>
	        A presto con i prossimi consigli, aggiorneremo direttamente questa pagina!<br>
	        Grazie dell'attenzione.
				</p>
        <p>
					Se hai bisogno di supporto scrivi al tuo coordinatore.
					<br>
					<em>Il team ClickDay.it</em>
				</p>
      </div>
			
			<h2 style="text-align: center;">BUON ALLENAMENTO! 💪</h2>
			
			<br>
			<div style="text-align: justify; font-size:14px; line-height: 1.3;">
				Questi documenti sono di proprietà esclusiva di EMPATIK SRL UNIPERSONALE. È espressamente proibito, anche solo parzialmente, copiare, riprodurre, distribuire, trasmettere, trasferire, pubblicare, divulgare le informazioni contenute in questi documenti, compresi i contenuti, le illustrazioni, le formule e ogni altro elemento rappresentativo, senza il preventivo consenso scritto di EMPATIK SRL UNIPERSONALE.
È inoltre proibito utilizzare le informazioni qui presenti per trarre profitto al di fuori della collaborazione stabilita con EMPATIK SRL UNIPERSONALE.
Il mancato rispetto delle suddette condizioni costituisce violazione della Legge Italiana n. 633/1941 e successive modificazioni e integrazioni, e/o altre leggi nazionali e internazionali in materia di protezione della proprietà intellettuale e industriale e sarà perseguita a norma di legge.   
			</div>
		</div>
	</v-container>
	
	<v-dialog
		v-model="testYoutubeDialog"
		persistent
		scrollable
	>
		<v-card>
			<v-card-title>
				Test YouTube
			</v-card-title>
			<v-card-text>
				<div class="responsive-youtube">
					<iframe
						src="https://www.youtube.com/embed/XMNY8WkcwS0?si=HCQBGRHx56wPsgPj "
						title="YouTube video player"
						frameborder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						referrerpolicy="strict-origin-when-cross-origin"
						allowfullscreen
					></iframe>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					@click="testYoutubeDialog = false"
					color="primary"
				>
					Chiudi
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	
	<v-dialog
		v-model="googleDocDialog"
		:key="googleDocDialogKey"
		persistent
		scrollable
	>
		<v-card style="height: 100%">
			<v-card-title>
				{{ cardItemSelected.text }}
			</v-card-title>
			<v-card-text>
				<!--<iframe-->
				<!--	src="https://docs.google.com/document/d/e/2PACX-1vTUmXcRhEWKN8GgXgBxDdjJWKKzZstm6hpo9noBHU4KQgkhsQyypq0VMv_rsAhqbc23dT9FWukW5BrK/pub?embedded=true"-->
				<!--	width="100%"-->
				<!--	height="100%"-->
				<!--&gt;</iframe>-->
				
				<!-- per regolare l'altezza del documento usare il padding-bottom -->
				<div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 200%;">
					<iframe
						:src="cardItemSelected.link"
						style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;"
						allowfullscreen
					></iframe>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					@click="googleDocDialog = false"
					color="primary"
				>
					Chiudi
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	
</div>
</template>

<script>
export default {
  data() {
    return {
      cardItems: [
				{ 
					text: 'Cosa fare quando riscontri errori in una simulazione', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vTZ39EFitBAZ9GjU6PefsLmpgpP61PuGYAOiPdNPnFqZqB8Uuflkc_IDOY5Tp-kr1DFsLVflLTzOmDH/pub',
					image: '/img/img_consigli/cnsl-img-1.jpg',
					desc: 'Ti sei mai chiesto se un errore in una simulazione è davvero un bug o un tuo sbaglio? Scopri come capirlo e migliorare i tuoi risultati!',
					stato: 'FONDAMENTALE'
				},

				{ 
					text: 'Gli Errori più comuni e i Trabocchetti da conoscere', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vS6sD_dzf5G0XBGbr5OzHA7hwlv1gvgQgfY4s1WssuH6H6GjSj-PvS7ivySEid4Ng-m-87RSITWJOUs/pub',
					image: '/img/img_consigli/cnsl-img-3.jpg',
					desc: 'Non lasciare che un piccolo errore ti costi il successo al Click Day: scopri come evitare le trappole più insidiose!' ,
					stato: 'FONDAMENTALE'
				},
				{
					text: 'X-Mouse Button Control: guida all’uso per Windows', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vSGavxwOIT-ORD_Mkuf5NGk0qOjjeOgPE5b59583H6MEQeu2FpSFAnXfgY2EiCX8A8OuotyKmL0RhAx/pub',
					image: '/img/img_consigli/cnsl-img-11.jpg',
					desc: 'Vuoi aumentare la velocità dei tuoi click? Scopri come configurare X-Mouse Button Control per ottimizzare i pulsanti del mouse e guadagnare preziosi secondi!', 
					stato: 'FONDAMENTALE'
				},

				{ 
					text: 'Steer Mouse: guida all’uso per MAC', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vRDSn3LItactUe7F0EF17k9S6VQ-xRB0A_UIrw5oGFBxYKxYUpe8xeL1mxhD70DdG-Gac2rt1PKKJ5b/pub',
					image: '/img/img_consigli/cnsl-img-12.jpg',
					desc: 'Usi un Mac per il Click Day? Scopri come configurare SteerMouse e ottimizzare i pulsanti del mouse per dare un boost alla tua velocità e precisione!',
					stato: 'FONDAMENTALE',
				},

				{ 
					text: 'Dai priorità alla precisione piuttosto che alla velocità', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vS87K7JHBoQmD2sAdRZ2wgvhH0ZGAHLq4rxsqOo_hE1CmsXCaFwWJo-X_y2k78tjZ72Sx-K5a1EsY3Q/pub',
					image: '/img/img_consigli/cnsl-img-4.jpg',
					desc: 'La chiave per vincere il Click Day? Precisione, non velocità! Scopri come evitare gli errori comuni con un metodo di lettura infallibile.',
					stato: 'FONDAMENTALE'
				},
				{ 
					text: "Sfrutta ogni millisecondo con time.is",
					link: 'https://docs.google.com/document/d/e/2PACX-1vTI6cJyYS4eUV89OMdJNAD8F62Smms0hZ8_2pDcOmKlqyELsLlrH_UBtJvrL_efH4IY5XZsarKEYosK/pub',
					image: '/img/img_consigli/cnsl-img-26.jpg',
					desc: 'Vuoi sfruttare ogni millisecondo al Click Day? Scopri come organizzare la tua postazione per non perdere neanche un istante e fare la differenza!',
					stato: 'FONDAMENTALE'
				},
				{ 
					text: "Utilizza al meglio la Finestra Dati Personali*", 
					link: 'https://docs.google.com/document/d/e/2PACX-1vQvtNKfuGEGN9aEwDpr79sNpCRoSqwGCD3mkmEft1g-wk_6ZLcZIspwiyVPapIPI9h-lxltxYOxj8Iy/pub',
					image: '/img/img_consigli/cnsl-img-8.jpg',
					desc: 'Sai come sfruttare al massimo la Finestra Dati Personali? Scopri i trucchi per risparmiare tempo prezioso e copiare i dati senza errori al prossimo Click Day!',
					stato: 'FONDAMENTALE'
				},
				{ 
					text: 'Ottimizza lo zoom della pagina', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vTNz-kgK8Z5sPnkRVPD1VE-cQEEmJckM9vqpPYXydzcQ98Lh9bG1R8Fbm3UbUWUKNEYwa9FQgMRXrCR/pub',
					image: '/img/img_consigli/cnsl-img-15.jpg',
					desc: "Scopri come regolare lo zoom del browser per visualizzare più domande senza scorrere nella pagina e individuare ogni errore a colpo d'occhio!",
					stato: 'FONDAMENTALE'
				},
				{ 
					text: "Sii pronto all'imprevedibile", 
					link: 'https://docs.google.com/document/d/e/2PACX-1vSpyzRpUTvQy35VUFZNwnkLfCr5OkTYeMkakWvyUqet3N1HqId1GuW5ICUYTn4sWVRkP0RzXAZ__x8O/pub',
					image: '/img/img_consigli/cnsl-img-6.jpg',
					desc: 'Pensi di essere pronto per il Click Day? Scopri perché l’imprevedibile è il tuo vero avversario e come trasformarlo in un vantaggio!',
					stato: 'FONDAMENTALE'
				 },

				 { 
					text: 'Simulazioni abbandonate', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vT6F1aK-QeWuUNJjLn0wJzODboUQGTOhCL9j1778Nic0IpRZo5D2j_jZ7bt9j_b8s7SShxXhgMhgpae/pub',
					image: '/img/img_consigli/cnsl-img-9.jpg',
					desc: 'Ti capita di abbandonare simulazioni? Scopri come questo influisce sul tuo WINSCORE e sulla Selezione e perché affrontare ogni simulazione fino alla fine può essere la tua arma vincente al Click Day!',
					stato: 'FONDAMENTALE'
				},

				{ 
					text: "Respira e gestisci meglio l'ansia (aspetti psicologici)", 
					link: 'https://docs.google.com/document/d/e/2PACX-1vQ6vAogIZAvXWOTPrPNuqWAgyMn9Aw0iQZrVwL4vWw4kIIqrEB_hm7KHudz2wrCjF-fmCpSBMIsnDyz/pub',
					image: '/img/img_consigli/cnsl-img-5.jpg',
					desc: 'Affronta il Click Day con calma e lucidità: scopri i segreti per gestire l’ansia e aumentare le tue possibilità di successo!',
					stato: 'FONDAMENTALE'
				},

				{ 
					text: "Velocizzare il copia-incolla se si ha uno schermo grande", 
					link: 'https://docs.google.com/document/d/e/2PACX-1vRNlvJIKbkXOw-Qyuf3VGAc70gmsOnZJL_pAjQNMUV70_B8cidIKkwb_E_mDMeewvoojPfiNLI6yjCt/pub',
					image: '/img/img_consigli/cnsl-img-20.jpg',
					desc: 'Usi uno schermo grande? Scopri come organizzare al meglio le finestre e lo zoom per velocizzare il copia-incolla e risparmiare secondi preziosi al Click Day!',
					stato: ''
				},

				{ 
					text: 'Connessione Internet', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vRArcnrazQKaKNtl7Z1Q62DOLX1HbLBHaGtNN06VfpdsmbnqqzDWWiuOOde6Yynx6ntOoqIJThBzfBV/pub',
					image: '/img/img_consigli/cnsl-img-16.jpg',
					desc: 'Connessione lenta? Rischi di perdere il Click Day! Scopri i requisiti di connessione ideali e come ottimizzare la tua rete per una performance impeccabile.',
					stato: ''
				},
        { 
					text: 'Aumenta le prestazioni del tuo PC', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vRGL59ZnlldpRqGI8oY04ZSJqkNF8qLZ6syiS1gcuO-jVa595J9DPDXWlJfIJ9T_Okl2Cb_WPEY3mwP/pub',
					image: '/img/img_consigli/cnsl-img-18.jpg',
					desc: 'Ottimizza il tuo PC per il Click Day: scopri come liberare risorse chiudendo le applicazioni inutili e ottenere il massimo delle prestazioni!',
					stato: ''
				},
        { 
					text: 'Mouse e Trackpad', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vRXy-ACgKQTsB9Feiaj9sc_Nnf8hghizvjJk65VEETg_18dMwT2IpS8WxU8mlpqSJXryZ5WOR7FAqNn/pub',
					image: '/img/img_consigli/cnsl-img-17.jpg',
					desc: 'Mouse o trackpad al Click Day? Scopri come preparare al meglio la tua attrezzatura per evitare imprevisti e garantire una performance impeccabile nei momenti cruciali!',
					stato: ''
				},
				{ 
					text: 'Vietato usare Safari e altri browser non supportati', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vRkr641aOYcQIZhtyzwBmOVMS8SavfTSuhe0xl6ark2tr50Ja1DYiBB-q3Ev1pBw9HptH8w18PmNvfn/pub',
					image: '/img/img_consigli/cnsl-img-21.jpg',
					desc: 'Evita brutte sorprese al Click Day: scopri quali browser usare per non rischiare rallentamenti e invii bloccati!' ,
					stato: ''
				}, 
				{
					text: 'Rivivi i GAME DAY',
					link: 'https://docs.google.com/document/d/e/2PACX-1vTL9SIhFI186a9u3BMrnZ-GzgU_M31QggUxcrJaWbOdwjXN_Izi9fAFtKrMrJODNR7OuXqGiBbJqfa9/pub',
					image: '/img/img_consigli/cnsl-img-13.jpg',
					desc: 'Rivivi ogni Game Day e perfeziona la tua strategia! Ora puoi rivedere i Game Day passati nel simulatore: scopri come usare questo strumento per allenarti e migliorare le tue performance!', 
					stato: ''
				},
				{ 
					text: 'Preparati al meglio per il giorno del Click Day', 
					link: 'https://docs.google.com/document/d/e/2PACX-1vRenjNZcPSa6czwEe-1l3jeBXZqPFcNbABlJExy-JXR0VQ1mQOW52M0aBF0ZboqgGsT10oZ_YWqRW8Q/pub',
					image: '/img/img_consigli/cnsl-img-10.jpg',
					desc: 'Sei davvero pronto per il Click Day? Segui questa checklist per evitare distrazioni e garantire la connessione perfetta: ogni dettaglio conta per arrivare al successo!',
					stato: ''
				},
				{	
					text: 'Guarda come sono stati 2 tra gli ultimi ClickDay', 
				 	link: 'https://docs.google.com/document/d/e/2PACX-1vSrJ4CUYpwaxWQ6GVDnzsYct7fvC7d2IPxxkgZnQ3onU1wleK1a6wqJwbTZRTVXZy7EwkNSbVQkoopt/pub',
				 	image: '/img/img_consigli/cnsl-img-14.jpg',
				 	desc: 'Vuoi sapere cosa ti aspetta al prossimo Click Day? Guarda i video dei precedenti Click Day e scopri come affrontare schermate imprevedibili e situazioni spiazzanti per essere pronto a tutto!',
					stato: '' 
				},
				{
				 	text: 'Video con consigli e strategie per vincere!', 
				 	link: 'https://docs.google.com/document/d/e/2PACX-1vTXe3oJaCjXhRSpyNfSi5665XRc3l7_IttwYTZ4BZ0WQhevRPGQd620gz1kE6GLRkAYhRNhbwRDzpxd/pub',
				 	image: '/img/img_consigli/cnsl-img-22.jpg',
				 	desc: 'Vuoi massimizzare le tue chance di vittoria? Guarda il nostro video con 12 strategie collaudate per affrontare al meglio i Game Day* e il Click Day!',
					stato: ''  
				 },
				// { 
				// 	text: '', 
				// 	link: '',
				// 	image: '',
				// 	desc: '' ,
				// 	stato: ''
				// },



				// {
				// 	text: 'Accedi alla schermata del Click al momento giusto', 
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vSNo0CKDIbO8QqSIbzqip-jF11q232jnAgcQcgNrsD_2OluwnG8mg4A8k0FJsmcWBJP0bhKh8R47tMa/pub',
				// 	image: '/img/img_consigli/cnsl-img-7.jpg',
				// 	desc: 'Aspettare il secondo spaccato, premere un pelo prima o attendere qualche istante in più? Scopri il momento perfetto per accedere alla schermata del Click!',
				// 	stato: 'FONDAMENTALE'
				// },
				// {
				// 	text: 'Impara come sfruttare al meglio le Macro', 
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vRoGpId3Lu8KnVb7AZq8fgo7IicNcuWzKTQ09wbYWe51NmIdzDTva1IGlCqCRgKWI9AH8jQWUySPwde/pub',
				// 	image: '/img/img_consigli/cnsl-img-2.jpg',
				// 	desc: 'Come superare le limitazioni del copia-incolla e rispondere velocemente? Scopri il trucco delle macro per simulare la digitazione perfetta, anche nei campi più ostici!',
				// 	stato: 'FONDAMENTALE'
				// },
				// { 
				// 	text: 'Impara a personalizzare le Macro (senza fare danni)', 
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vT81_nE0dliIftOWoKnwKczIafHB7M2LCB1fjLip6OKROxfwOlsvZJOyM8siNoYZJ7ncj1Ojyo6rI1R/pub',
				// 	image: '/img/img_consigli/cnsl-img-25.jpg',
				// 	desc: 'Rendi le Macro tue alleate:scopri come adattarle alle tue esigenze senza compromettere le loro funzionalità cruciali per il Click Day',
				// 	stato: 'FONDAMENTALE'
				// },
				



				//  { 
				// 	text: "Sfrutta ogni millisecondo con time.is",
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vSslNepNBGGkW_jW9vXF2SH3jHuRLv5X3eLToIJ69i3JNRC-6bA8MutgKHTagQA8xdYFBCjjbC487xb/pub',
				// 	image: '/img/img_consigli/cnsl-img-26.jpg',
				// 	desc: 'Vuoi sfruttare ogni millisecondo al Click Day? Scopri come organizzare la tua postazione per non perdere neanche un istante e fare la differenza!',
				// 	stato: 'AGGIORNATO'
				// },
				// { 
				// 	text: "Sfrutta al meglio la Finestra Dati Personali", 
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vRN3E7H8oBudwnRk_0fR1-291prZ3Xfj9cDnkOYzPwLhbFWbyj-dnfRgFhscDQIQP2lYgYhe1Ie_Xnc/pub',
				// 	image: '/img/img_consigli/cnsl-img-8.jpg',
				// 	desc: 'Sai come sfruttare al massimo la Finestra Dati Personali? Scopri i trucchi per risparmiare tempo prezioso e copiare i dati senza errori al prossimo Click Day!',
				// 	stato: 'AGGIORNATO'
				// },


        // {  DISABILITATA PER IL CLICK DAY IN CORSO - NIKHIL 02-12-2024
				// 	text: 'X-Mouse Button Control: guida all’uso per Windows', 
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vTvsIYWwQplmUGTyH9GXLU8ogurUogBDkANBf3_Vww1bqHK257kljzeCjrl6x4yxciCntYiL_SCNI9z/pub?embedded=true',
				// 	image: '/img/img_consigli/cnsl-img-11.jpg',
				// 	desc: 'Vuoi aumentare la velocità dei tuoi click? Scopri come configurare X-Mouse Button Control per ottimizzare i pulsanti del mouse e guadagnare preziosi secondi!' 
				// },

        // {  DISABILITATA PER IL CLICK DAY IN CORSO - NIKHIL 02-12-2024
				// 	text: 'Rivivi i GAME DAY',
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vRvowXCvfX622X27blYQzNQxBhDmIoel1oefOKZQwD-rBr2BUH6aFfysl5hAwalN48yFR0-9nhXBGMS/pub?embedded=true',
				// 	image: '/img/img_consigli/cnsl-img-13.jpg',
				// 	desc: 'Rivivi ogni Game Day e perfeziona la tua strategia! Ora puoi rivedere i Game Day passati nel simulatore: scopri come usare questo strumento per allenarti e migliorare le tue performance!' 
				// },
        // {  DISABILITATA PER IL CLICK DAY IN CORSO - NIKHIL 02-12-2024
				// 	text: 'Guarda come sono stati gli ultimi 2 ClickDay', 
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vSJ-Wv6iZmL2AVBXOtnAT3XQt84P8H-4PVs1hYeB2wxrxw1e_ntwIEQ7mX1yYXMxEcx6g9DnkkP4pUz/pub?embedded=true',
				// 	image: '/img/img_consigli/cnsl-img-14.jpg',
				// 	desc: 'Vuoi sapere cosa ti aspetta al prossimo Click Day? Guarda i video dei precedenti Click Day e scopri come affrontare schermate imprevedibili e situazioni spiazzanti per essere pronto a tutto!' 
				// },
				// { 
				// 	text: 'Regola al meglio lo zoom della pagina', 
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vRpNjzHDeDBQYsxl3OfuUwmYkvwp8H86vUlLYlq_rsnKTN_TCuuPbcIhv064QZSPQm9inKuGKdW9D8p/pub',
				// 	image: '/img/img_consigli/cnsl-img-15.jpg',
				// 	desc: "Scopri come regolare lo zoom del browser  per visualizzare più domande senza scorrere nella pagina e individuare ogni errore a colpo d'occhio!",
				// 	stato: 'FONDAMENTALE'
				// },



        // { 
				// 	text: 'Velocizzare il copia-incolla se si ha uno schermo grande', 
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vSp5UuADoGtz6WRuZF5LbkptGIyrnEjOPmlFU6s0csycPsyEyz0uHUrfJSJ8B27yo9X9j1vLuoYrwdj/pub',
				// 	image: '/img/img_consigli/cnsl-img-20.jpg',
				// 	desc: 'Usi uno schermo grande? Scopri come organizzare al meglio le finestre e lo zoom per velocizzare il copia-incolla e risparmiare secondi preziosi al Click Day!',
				// 	stato: ''
				// },

        // {  DISABILITATA PER IL CLICK DAY IN CORSO  - NIKHIL 02-12-2024

			
				// { TEMPORANEAMENTE DISABILITATA - NIKHIL 02-12-2024 => da riattivare quando lo dice Simone
				// 	text: 'Come gestire gli errori di caricamento e di sistema della pagina del Click', 
				// 	link: 'https://docs.google.com/document/d/e/2PACX-1vT1KSTxI7bZRbgjyX4tBA0w8LlB3P7M3ejBtM0fquiNU219V4US4gZoVbUcOlThbdyK8a78zbYkd9zg/pub?embedded=true',
				// 	image: '/img/img_consigli/cnsl-img-23.jpg',
				// 	desc: 'Pagina bloccata o errori di sistema? Scopri come risolvere rapidamente e tornare in carreggiata senza perdere tempo prezioso!',
				//  stato: 'NUOVA'
				// },
      ],
	    
	    testYoutubeDialog: false,
	    googleDocDialog: false,
	    googleDocDialogKey: 0,
	    
	    cardItemSelected: {
				text: null,
		    link: null,
		    image: null
	    }
    };
  },
	methods: {
		openGoogleDocDialog(item) {
			this.googleDocDialogKey++;
			this.cardItemSelected = item;
			this.googleDocDialog = true;
		}
	}
}

</script>


<style lang="scss" scoped>

.appcontainer {
	margin: 1rem 2rem;
}

#app p { margin-bottom: 0.25rem;}
#app h3 {margin-bottom:1rem;}
#app ul li {border-bottom:1px solid #E0E0E0; padding:0.3rem;}
#app ul {margin-bottom: 1rem;}

.v-card.custom-card {
  height: 100%;
  background-size: cover;
  background-position: center;
	border-radius: 0px;
  color: white;
	// font-size:18px;
	font-weight: 600;
	line-height: 1.3;
	text-shadow: 2px 3px 5px #1a1a1a;
	transition: all 0.5s;
}

.overlay {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1rem 2rem;
	transition: all 0.5s;
}

.v-card.card-hover-animation:hover {
	transform: scale(1.025);
	// border: 5px solid #6D93CC;
}

.overlay:hover {
	background: rgba(0, 0, 0, 0.3);
	cursor:pointer;
}

.same-size-card {
  height: 150px !important; 
  width: 100%;
  background-size: cover;
  background-position: center;
  overflow: hidden; 
}

.card-description {
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  padding: 0.5rem;
	padding-top:1rem;
  text-align: left;
}


.responsive-youtube {
	height: 0;
	overflow: hidden;
	padding-bottom: 56.25%;
	padding-top: 30px;
	position: relative;
}
.responsive-youtube iframe,
.responsive-youtube object,
.responsive-youtube embed {
	height: 100%;
	left: 0;
	position: absolute;
	top: 0;
	width: 100%;
}

::v-deep {
	.v-dialog {
		height: 100% !important;
	}
}
.status-badge {
  font-size: 0.6rem;
  font-weight: 600;
	letter-spacing: 1px;
  color: white;
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
  text-align: center;
  display: inline-block;
  margin-bottom: 0.5rem;
  text-shadow: none !important;
  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  position: absolute;
  top: 10px;
  right: 10px;
}

.status-fondamentale {
  background-color: #9333ea;
}

.status-aggiornato {
  background-color: #f59e0b;
}

.status-nuovo {
  background-color: #059669;
}

.border-fondamentale {
  border: 4px solid #9333ea;
}

.border-aggiornato {
  border: 4px solid #f59e0b;
}

.border-nuovo {
  border: 4px solid #059669;
}

.v-card.custom-card {
  transition: all 0.5s ease; 
}



.overlay {
  position: relative; /* Rende il contenitore il riferimento per il badge */
}



</style>